import { getSafetySurvey,getViolationTrend,getViolationAnalysis,getCarViolationDetail } from "../../api/config/modules/SecureAnalysis";

const state = {
    getSafetySurvey: {},
    getViolationTrend: {},
    getViolationAnalysis: {},
    getCarViolationDetail: {}
};

const mutations = {
  SET_GETSAFETYSURVEY: (state, getSafetySurvey) => {
    state.getSafetySurvey = getSafetySurvey;
  },
  SET_GETVIOLATIONTREND: (state, getViolationTrend) => {
    state.getViolationTrend = getViolationTrend;
  },
  SET_GETVIOLATIONANALYSIS: (state, getViolationAnalysis) => {
    state.getViolationAnalysis = getViolationAnalysis;
  },
  SET_GETCARVIOLATIONDETAIL: (state, getCarViolationDetail) => {
    state.getCarViolationDetail = getCarViolationDetail;
  },
};

const actions = {
  GET_GETSAFETYSURVEY: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getSafetySurvey(data)
        .then((res) => {
          commit("SET_GETSAFETYSURVEY", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETVIOLATIONTREND: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getViolationTrend(data)
        .then((res) => {
          commit("SET_GETVIOLATIONTREND", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETVIOLATIONANALYSIS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getViolationAnalysis(data)
        .then((res) => {
          commit("SET_GETVIOLATIONANALYSIS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCARVIOLATIONDETAIL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getCarViolationDetail(data)
        .then((res) => {
          commit("SET_GETCARVIOLATIONDETAIL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
